// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"d4c04f89","545":"c625c013"}[chunkId] + ".chunk.js";
};